import { AfterViewInit, Component, Input, Output, ElementRef, EventEmitter, OnInit, ViewEncapsulation } from '@angular/core';

declare const $: any;

@Component({
  selector: 'loadcharge',
  template: `
  <form *ngIf="containers.length > 0" class="form-inline">
    <fieldset class="form-group">
        <input name="loadchargetype" type="radio" id="volume" [checked]="type == 'volume'" (click)="type='volume'">
        <label style="padding-left: 35px;" for="volume">Volume</label>
    </fieldset>
    <fieldset class="form-group">
        <input name="loadchargetype" type="radio" id="weight" [checked]="type == 'weight'" (click)="type='weight'">
        <label style="padding-left: 35px;" for="weight">Weight</label>
    </fieldset>
  </form>
  <div *ngFor="let container of containers" class="row">
    <div class="col-md-12" data-toggle="tooltip" title="{{container.loadCharge}} %">
        {{container.name}}
        <div class="progress">
            <div class="progress-bar" [ngClass]="{'bg-warning': container.loadCharge > 25 && container.loadCharge <= 50,'bg-info': container.loadCharge > 50 && container.loadCharge <= 75,'bg-success': container.loadCharge > 75 && container.loadCharge <= 100,'bg-danger': (container.loadCharge > 0 && container.loadCharge <= 25) || container.loadCharge > 100}"
                role="progressbar" [ngStyle]="{ width: container.loadCharge + '%' }" aria-valuenow="container.loadCharge" aria-valuemin="0"
                aria-valuemax="100"></div>
        </div>
    </div>
  </div>`,
})

export class LoadchargeComponent {
  @Input() public name: string = '';
  @Output() updated: EventEmitter<string> = new EventEmitter<string>();
  public _type: string = 'weight';
  public _containers: any[] = new Array<any>();
  public inited: boolean = false;

  constructor() {
    this.type = this._type;
    this.inited = true;
  }

  public set containers(containers: any[]) {
    let _containers: any[] = new Array<any>();
    for (let i = 0; i <= containers.length - 1; i++) {
      _containers.push({ name: containers[i].name, loadCharge: containers[i].loadCharge });
    }
    this._containers = _containers;
  }

  public get containers(): any[]{
    return this._containers;
  }

  public set type(type: string) {
    this._type = type;
    if (this.inited) this.updated.emit(type);
  }

  public get type(): string{
    return this._type;
  }

  loadChargeStyle(container: any) {
    return {
      width: container.loadCharge + '%'
    };
  }
}
